<div class="modal-content">
  
    <h2>Operator List</h2>
    <div class="text-right">
        <mat-icon mat-dialog-close class="close-button">close</mat-icon>
    </div>
       <div class="content">
        <!-- <app-custom-dropdown 
        [placeholder]="'OperatorList'"
       
        [items]="operatorlistOptions"
        [controlname]="this.myshipForm.controls['operatorList']"></app-custom-dropdown> -->
        <form [formGroup]="myshipForm">
        <select id="operator-select" class="form-control" formControlName="eigerPic">
        <option value="all">ALL</option>
        <option *ngFor="let operator of operatorlistOptions" [value]="operator.value">
          {{ operator.label }}
        </option>
      </select>
    </form>
    </div>

    <div class="row">
        <button type="button" class="btn btn-light hover-clear clear" (click)="closeModal()">
            <span>Cancel</span>
        </button>
        <button type="button" class="btn btn-light hover-clear clear" (click)="submit()">
            <span>Submit</span>
        </button>
    </div>

</div>